// extracted by mini-css-extract-plugin
export var menuIcon = "_qx-0";
export var menuIconInline = "_qx-1";